import { ActionIcon, Badge, Box, Button, Checkbox, Divider, FileInput, Grid, Group, Loader, Menu, Modal, Paper, Select, Text, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect } from 'react';
import { FaDownload, FaEllipsisV, FaFileExport, FaFilter, FaMap, FaNetworkWired, FaPencilAlt, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import InputField, { InputFieldTypes } from '../components/input_field';
import SimpleHeader from '../components/simple_header';
import { useApp } from '../contexts/app.context';
import { DELETE_DEVICE, GET_ALL_DEVICES, GET_ALL_DEVICE_MODELS, SAVE_DEVICE, TRANSFER_DEVICES, TRIGGER_DEVICE_COMMAND } from '../services/devices';
import { GET_ALL_APNS } from '../services/apns';
import { getDeviceTitle, getExtenseDatetime } from '../utility/util';
import moment from 'moment';
import { Buffer } from 'buffer';
import Table from '../components/table';
import { useAuth } from '../contexts/auth.context';
import { VehicleDevice } from './vehicles';
import Commands from './commands';

export default function DevicesPage(){
    const [items, setItems] = React.useState<any[]>([]);
    const [modal, setModal] = React.useState<any>(null);
    const [loadingItems, setLoadingItems] = React.useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = React.useState({});
    const [loadingTransfer, setLoadingTransfer] = React.useState(false);
    const [loadingExporting, setLoadingExporting] = React.useState(false);
    const [transfering, setTransfering] = React.useState(null);
    const [vehicleDevice, setVehicleDevice] = React.useState(null);
    const [lastComunication, setLastComunication] = React.useState<any>({});
    const [selecteds, setSelecteds] = React.useState<string[]>([]);
    const [filters, setFilters] = React.useState<any>({ title: "" });
    const [loadingTriggers, setLoadingTriggers] = React.useState<any>({});

    const filteredItems = items.filter(i => (
        getDeviceTitle(i).toLocaleLowerCase().includes(filters.title.toLocaleLowerCase())
    ))

    const app = useApp();
    const { currentCompany, companies } = useAuth();
    const { socket } = useApp();
    const navigate = useNavigate();

    const loadItems = () => {
        setLoadingItems(true)
        GET_ALL_DEVICES()
        .then(res => {
            setItems(res);
            setLoadingItems(false)
        })
        .catch(err => {
            setLoadingItems(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const deleteItem = (deviceId) => {
        setLoadingDelete(ld => ({...ld, [`${deviceId}`]: true}))
        DELETE_DEVICE(deviceId)
        .then(res => {
            setLoadingDelete(ld => ({...ld, [`${deviceId}`]: false}))
            loadItems()
        })
        .catch(err => {
            setLoadingDelete(ld => ({...ld, [`${deviceId}`]: false}))
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    const handleTransfer = () => {
        setLoadingTransfer(true)
        TRANSFER_DEVICES(transfering)
        .then(res => {
            setLoadingTransfer(false)
            loadItems();
            setSelecteds([]);
            setTransfering(null);
            showNotification({ message: "Dispositivos transferidos", color: 'blue'});
        })
        .catch(err => {
            setLoadingTransfer(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    const handleExport = () => {
        setLoadingExporting(true);

        let csvText = [
            [
                "Modelo",
                "IMEI",
                "Number",
                "SSID",
                "Host",
                "Data Cadastro",
                "Veículo - Placa",
                "Veículo - Marca",
                "Veículo - Modelo",
            ],
            ...items.filter(i => selecteds.includes(i._id)).map(item => [
                item?.model?.title,
                item?.props?.DEV_ID,
                item?.props?.CHIP_NO,
                item?.props?.SSID_CHIP,
                item?.apn?.host,
                item?.createdAt,
                item?.vehicles[0]?.vehicle?.license_plate,
                item?.vehicles[0]?.vehicle?.brand,
                item?.vehicles[0]?.vehicle?.model,
            ])
        ].map(items => items.map(it => `"${it ?? ""}"`).join(",")).join("\n")
    
        const byteCharacters = Buffer.from(csvText, "utf-8");
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters[i]; }
        const byteArray = new Uint8Array(byteNumbers);
    
        const blob = new Blob([byteArray], { type: "application/csv" });
    
        const url = URL.createObjectURL(blob);;
        const a = document.createElement('a');
        a.href = url;
        a.download = `Dispositivos_Satify.csv`;
        a.click();
        URL.revokeObjectURL(url);

        setLoadingExporting(false);
    }

    const triggerCommand = (deviceId: string, key: string) => {
        setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: true }}))
        TRIGGER_DEVICE_COMMAND(deviceId, key)
        .then(res => {
            showNotification({message: "Comando enviado", color: "orange"})
            setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: false }}))
        })
        .catch(err => {
            showNotification({message: err.message, color: "red"})
            setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: false }}))
        })
    }

    useEffect(() => {
        if(socket){
            const callback = (deviceId) => ({ history }) => {
                setLastComunication(lc => ({ ...lc, [deviceId]: history}))
            }
            let lcs : any = {};
            for(let d of items){
                lcs[`${d._id}`] = d.lastHistory
                socket.on(`device-history-received-${d._id}`, () => { callback(d._id) });
            }
            setLastComunication(prev => ({...prev, ...lcs}));
            return () => {
                for(let d of items){ socket.off(`device-history-received-${d._id}`, () => { callback(d._id) }) }
            }
        }
      }, [socket, items])

    useEffect(loadItems, []);

    return <>
        <SimpleHeader title="Dispositivos" right={
            <Group>
                {/* <Menu>
                    <Menu.Target><Button
                        disabled={selecteds.length === 0}
                        leftIcon={<FaDownload />} variant='outline'>({selecteds.length}) Comandos</Button></Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Item onClick={() => exportCommands("configs")}>Configuração</Menu.Item>
                        <Menu.Item onClick={() => exportCommands("block")}>Bloquear</Menu.Item>
                        <Menu.Item onClick={() => exportCommands("unblock")}>Desbloquear</Menu.Item>
                    </Menu.Dropdown>
                </Menu> */}
                <Menu>
                    <Menu.Target>
                        <ActionIcon color="orange" variant='filled' size="lg"><FaFilter /></ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <InputField
                            name="title"
                            onChange={({title}) => setFilters(f => ({ ...f, title }))}
                            value={filters.title}
                            placeholder='Buscar'
                            size="md"
                        />
                    </Menu.Dropdown>
                </Menu>
            </Group>
        }
        buttons={[
            {leftIcon: <FaPlus />, title: "Dispositivo", onClick: () => { setModal(true)}},
            {leftIcon: <FaNetworkWired />, disabled: selecteds.length === 0, title: `${selecteds.length > 0 ? `(${selecteds.length}) ` : ''}Transferir`, onClick: () => { setTransfering({ items: selecteds }) }},
            {leftIcon: <FaFileExport />, loading: loadingExporting, disabled: selecteds.length === 0, title: `${selecteds.length > 0 ? `(${selecteds.length}) ` : ''}Exportar`, onClick: () => { handleExport() }},
        ]}  />
        
        <Table
            actions={[
                { leftIcon: <FaMap />, title: "Histórico", color: "gray", onClick: ({ item }) => navigate(`/dispositivos/${item._id}/historico`) },
                { leftIcon: <FaPencilAlt />, title: "Editar", color: "blue", onClick: ({ item }) => { setModal({
                    _id: item._id,
                    props: item.props,
                    model: item.model?._id ?? item.model,
                    apn: item.apn?._id ?? item.apn,
                }) } },
                { leftIcon: <FaTrash />, title: "Deletar", color: "red", onClick: ({ item }) => {
                            app.confirmDialog(
                                {text: "Realmente deseja deletar?"},
                                (({confirmed}) => {
                                    if(confirmed) deleteItem(item._id);
                                })
                            )
                        } },
            ]}
            columns={[
                {   
                    title: <Checkbox
                        checked={filteredItems.length > 0 && filteredItems.every(e => selecteds.includes(e._id))}
                        onChange={() => setSelecteds(s => (
                            filteredItems.every(e => selecteds.includes(e._id))
                            ? []
                            : filteredItems.map(i => i._id)
                        ))}
                    />,
                    key: "select", style: { width: 50 }, render: (item) => <Checkbox
                    checked={selecteds.includes(item._id)}
                    onChange={() => setSelecteds(s => (
                        selecteds.includes(item._id)
                        ? s.filter(it => it !== item._id)
                        : [...s, item._id]
                    ))}
                /> },
                { title: "Status", key: "status", style: { width: 180 }, render: (item) => <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {(!lastComunication[item._id]?.datetime || moment().diff(moment(lastComunication[item._id].datetime), "hours") >= 2)
                        ? <Badge size="xs" variant="filled" color="gray" mr="md"></Badge>
                        : lastComunication[item._id]?.props?.power === "on"
                            ? <Badge size="xs" variant="filled" color="green" mr="md"></Badge>
                            : <Badge size="xs" variant="filled" color="red" mr="md"></Badge>}
                    <Text size="xs" c="gray">{lastComunication[item._id] ? getExtenseDatetime(lastComunication[item._id].datetime) : ""}</Text>
                </div> },
                { title: "Modelo", key: "model", render: (item) => item?.model?.title },
                { title: "IMEI", key: "imei", render: (item) => item?.props?.DEV_ID },
                { title: "Número", key: "number", render: (item) => item?.props?.CHIP_NO },
                { title: "SSID", key: "ssid", render: (item) => item?.props?.SSID_CHIP },
                { title: "APN", key: "apn", render: (item) => item?.apn?.host },
                { title: loadingItems && <Loader size="sm" />, style: {width: 120}, key: "createdAt", render: (item) => <Text size="xs" c="gray">{getExtenseDatetime(item.createdAt)}</Text> },
                { title: "Comandos", style: { width: 100 }, key: "commands", render: (item) => (
                    <Menu>
                        <Menu.Target><Button variant="outline">Comandos</Button></Menu.Target>
                        <Menu.Dropdown>
                            <Menu.Item disabled={({...item?.model?.commands}["configs"] ?? []).length === 0}
                                onClick={() => triggerCommand(item._id, "configs")}>Configuração</Menu.Item>
                            <Menu.Item disabled={({...item?.model?.commands}["block"] ?? []).length === 0}
                                onClick={() => triggerCommand(item._id, "block")}>Bloquear</Menu.Item>
                            <Menu.Item disabled={({...item?.model?.commands}["unblock"] ?? []).length === 0}
                                onClick={() => triggerCommand(item._id, "unblock")}>Desbloquear</Menu.Item>
                            <Menu.Item disabled={({...item?.model?.commands}["position"] ?? []).length === 0}
                                onClick={() => triggerCommand(item._id, "position")}>Posição</Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                )  },
                !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title) && { key: "vehicle", title: "Veículo", render: (item) => <>
                    <Button size="sm" variant="outline" onClick={() => setVehicleDevice({deviceId: item._id, vehicleId: (item.vehicles ?? [])[0]?.vehicle?._id})}>
                        {(item.vehicles || []).length === 0 ? "Vincular" : item.vehicles[0]?.vehicle?.license_plate}
                    </Button>
                </>},

            ]}
            data={filteredItems
                .sort((a,b) => a.createdAt > b.createdAt ? -1 : 1)
            }
        />

        <DeviceModal
            data={modal}
            opened={!!modal}
            onClose={() => setModal(null)}
            onSave={(newItem) => {
                setItems(i => modal._id
                    ? i.map(it => it._id === modal._id ? newItem : it)
                    : [...i, newItem]);
                setModal(null)
            }}
        />

        <Commands />

        <VehicleDevice
            deviceOpt={false}
            vehicleOpt={true}
            vehicleId={vehicleDevice?.vehicleId}
            deviceId={vehicleDevice?.deviceId}
            opened={!!vehicleDevice}
            onClose={() => setVehicleDevice(null)}
            onSave={() => { loadItems(); setVehicleDevice(null) }}
        />

        <Modal
            opened={!!transfering}
            onClose={() => setTransfering(null)}
            styles={{ content: { minHeight: 500 } }}
        >
            <Select
                style={{flex: 1}}
                label="Selecione a empresa"
                styles={{input: {minWidth: 300}}}
                data={
                    companies
                    .filter(c => c.company.master)
                    .sort((a,b) => a.company.name > b.company.name ? 1 : -1)
                    .reduce((pv, master) => {
                    return [
                        { label: master.company.name.toUpperCase(), value: master.company._id, group: master.company.name.toUpperCase() },
                        ...pv.concat((master.company.children ?? []).map(c => ({
                        value: c._id, label: c.name ?? "".toUpperCase(), group: master.company.name.toUpperCase()
                        })))
                    ].sort((a,b) => a.label > b.label ? 1 : -1)
                    },[])
                    .filter(c => c.value !== currentCompany?.company?._id)
                }
                value={transfering?.companyId}
                name="companyId"
                clearable={false}
                searchable
                onChange={(companyId) => {
                    if(companyId){
                        setTransfering(t => ({...t, companyId}))
                    }
                }}
                >
                </Select>

            <Group mt="xl" style={{justifyContent: 'flex-end'}}>
                <Button loading={loadingTransfer} onClick={handleTransfer} disabled={!transfering?.companyId} size="md">Transferir</Button>
            </Group>
        </Modal>
    </>
}

const DeviceModal = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);
    const [models, setModels] = React.useState<any[]>([]);
    const [apns, setApns] = React.useState<any[]>([]);
    const [fileContent, setFileContent] = React.useState<any[]>([]);
    const [typeImport, setTypeImport] = React.useState<"single" | "file">("single");

    const handleChange = dt => setData(d => ({...d, ...dt}));
    const handleChangeProps = dt => setData(d => ({...d, props: { ...d?.props, ...dt }}));

    const handleSave = async () => {
        setLoadingSave(true)
        let items = [];
        if(typeImport === "file"){
            items = fileContent;
        }else{
            items = [{ ...data, id: dataParent?._id }]
        }

        await Promise.all(items.map(handleSaveSingle));
        setLoadingSave(false)
    }

    const loadModels = () => {
        GET_ALL_DEVICE_MODELS()
        .then(setModels)
        .catch(err => {
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    const loadApns = () => {
        GET_ALL_APNS()
        .then(setApns)
        .catch(err => {
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const handleSaveSingle = (dt) => {
        return new Promise((resolve, reject) => {
            SAVE_DEVICE(dt)
            .then((newItem) => {
                onSave && onSave(newItem);
                resolve(newItem);
            })
            .catch(err => {
                showNotification({title: "Ops", message: err.message, color: 'red'})
                reject(err)
            })
        })
    }

    const downloadTemplate = () => {
        const byteCharacters = Buffer.from([
            `Model;ID;Number`,
            `ST300;123123;61981818181`,
            `NT20;321321;11981818181`,
        ].join("\n"), "utf-8");
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters[i];
        }
        const byteArray = new Uint8Array(byteNumbers);
    
        const blob = new Blob([byteArray], { type: `application/csv` });

        const url = URL.createObjectURL(blob);;
        const a = document.createElement('a');
        a.href = url;
        a.download = `satify_import_template.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }

    useEffect(() => {
        if(opened) setData({...dataParent})
    }, [opened, dataParent])
    
    useEffect(() => {
        loadModels();
        loadApns();
    }, [])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="md"
            styles={{content: {minHeight: 500}}}
        >
            {!dataParent?._id && <InputField
                mb="lg"
                name="ti"
                value={typeImport}
                onChange={({ti}) => setTypeImport(ti)}
                fieldType={InputFieldTypes.SELECT}
                options={[
                    { value: "single", label: "Único Dispositivo" },
                    { value: "file", label: "Importar Arquivo" },
                ]}
            />}

            {
                typeImport === "file"
                ? <>
                    <Button color="orange" mb="md" variant="light" size="xs" onClick={() => downloadTemplate()}>Baixar modelo</Button>

                    <FileInput
                        onChange={file => {
                            const reader = new FileReader()
                            reader.onload = async (e) => { 
                                try{
                                    const text = (e.target.result) as string;
                                    let lines = text.split("\n");
                                    let indexes : any = {};
                                    lines[0].split(";").forEach((key, index) => {
                                        if(key.toLocaleLowerCase().includes("model")) indexes['model'] = index;
                                        if(key.toLocaleLowerCase().includes("id")) indexes['id'] = index;
                                        if(key.toLocaleLowerCase().includes("number")) indexes['number'] = index;
                                    });

                                    if([undefined, null, -1].includes(indexes['model'])) throw new Error("Insira no arquivo o campo 'model'");
                                    if([undefined, null, -1].includes(indexes['id'])) throw new Error("Insira no arquivo o campo 'id'");
                                    if([undefined, null, -1].includes(indexes['number'])) throw new Error("Insira no arquivo o campo 'number'");

                                    let content = lines.slice(1).map((line) => {
                                        const splited = line.split(";");
                                        return {
                                            origin: splited[indexes['model']].toLocaleLowerCase(),
                                            props: {
                                                DEV_ID: splited[indexes['id']],
                                                CHIP_NO: splited[indexes['number']],
                                            }
                                        }
                                    })
                                    setFileContent(content.filter(it => it.origin && it.props?.DEV_ID));
                                }catch(err){
                                    showNotification({ message: err.message, color: 'red' });
                                }

                            };
                            reader.readAsText(file)
                        }}
                        placeholder='Insira o arquivo conforme modelo' mb="md"></FileInput>

                    <Text>{(fileContent ?? []).length} - Itens inseridos</Text>
                </>
                : <>
                    <InputField
                        mb="lg"
                        name="model"
                        title="Modelo do Dispositivo"
                        fieldType={InputFieldTypes.SELECT}
                        options={models.map(m => ({value: m._id, label: m.title}))}
                        value={data?.model}
                        onChange={handleChange}
                    />
                    
                    <InputField
                        mb="lg"
                        name="apn"
                        title="APN"
                        fieldType={InputFieldTypes.SELECT}
                        options={apns.map(m => ({value: m._id, label: [m.provider, m.host].filter(nn => nn).join(" - ")}))}
                        value={data?.apn}
                        onChange={handleChange}
                    />

                    <InputField
                        mb="lg"
                        name="DEV_ID"
                        title="IMEI"
                        value={data?.props?.DEV_ID}
                        onChange={handleChangeProps}
                    />
                    <InputField
                        mb="lg"
                        name="SSID_CHIP"
                        title="SSID do Chip"
                        value={data?.props?.SSID_CHIP}
                        onChange={handleChangeProps}
                    />
                    <InputField
                        mb="lg"
                        name="CHIP_NO"
                        title="Número do Chip"
                        value={data?.props?.CHIP_NO}
                        onChange={handleChangeProps}
                    />
                </>
            }

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}